/* Iberic Deco - barra de compra fija en movil.
   Reutiliza el boton real del tema: no duplica logica de carrito ni de variantes. */
(function () {
  'use strict';

  if (window.__ibericStickyAtc) return;
  window.__ibericStickyAtc = true;

  var BTN = '.add-to-cart-button';

  function isProductPage() {
    return /\/products\//.test(window.location.pathname);
  }

  function realBtn() {
    return document.querySelector(BTN);
  }

  function readPrice() {
    var el = document.querySelector('.price');
    return el ? el.textContent.trim() : '';
  }

  function readLabel() {
    var el = document.querySelector('.add-to-cart-text__content');
    var txt = el ? el.textContent.trim() : '';
    return txt || 'Anadir al carrito';
  }

  function readTitle() {
    var h1 = document.querySelector('h1');
    return h1 ? h1.textContent.trim() : '';
  }

  function modalOpen() {
    return !!document.querySelector('dialog[open], .menu-drawer[open], .iberic-popup-open');
  }

  /* Solo escribe si cambia: evita que el observador se dispare a si mismo */
  function setText(el, value) {
    if (el.textContent !== value) el.textContent = value;
  }

  function init() {
    if (!isProductPage() || !realBtn()) return;

    var bar = document.createElement('div');
    bar.className = 'iberic-satc';
    bar.innerHTML =
      '<div class="iberic-satc__info">' +
      '<span class="iberic-satc__title"></span>' +
      '<span class="iberic-satc__price"></span>' +
      '</div>' +
      '<button type="button" class="iberic-satc__btn"></button>';
    document.body.appendChild(bar);

    var titleEl = bar.querySelector('.iberic-satc__title');
    var priceEl = bar.querySelector('.iberic-satc__price');
    var btnEl = bar.querySelector('.iberic-satc__btn');

    setText(titleEl, readTitle());

    function sync() {
      setText(priceEl, readPrice());
      setText(btnEl, readLabel());
      var rb = realBtn();
      btnEl.disabled = !rb || rb.disabled === true;
    }
    sync();

    /* El boton real hace todo el trabajo: variante, cantidad, cajon del carrito */
    btnEl.addEventListener('click', function () {
      var rb = realBtn();
      if (rb && !rb.disabled) rb.click();
    });

    /* Mostrar solo cuando el boton real ya no se ve */
    var ticking = false;
    function update() {
      ticking = false;
      var rb = realBtn();
      if (!rb) {
        bar.classList.remove('is-visible');
        return;
      }
      var r = rb.getBoundingClientRect();
      var show = (r.top > window.innerHeight || r.bottom < 0) && !modalOpen();
      bar.classList.toggle('is-visible', show);
    }
    function schedule() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });

    /* Observa solo el contenido de la pagina, nunca la propia barra */
    var target = document.getElementById('MainContent') || document.querySelector('main');
    if (target) {
      var pending = false;
      var obs = new MutationObserver(function () {
        if (pending) return;
        pending = true;
        window.requestAnimationFrame(function () {
          pending = false;
          sync();
          update();
        });
      });
      obs.observe(target, { childList: true, subtree: true, characterData: true });
    }

    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
